import { colorPalette } from "../../utils/constants";

export const customStyles = {
  iconGrid: {
    display: "flex",
    justifyContent: "center",
  },
  iconBox: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    padding: "16px",
    textAlign: "center" as const,
    width: "100%",
  },
  iconText: {
    color: colorPalette.white,
    fontSize: "16px",
    marginTop: "12px",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
  },
};
